import { render } from "./ChatDialog.vue?vue&type=template&id=bb3ebb5a&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"

import "./ChatDialog.vue?vue&type=style&index=0&id=bb3ebb5a&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3ebb5a"]])

export default __exports__